/* =============================================================================
File: App_v01.tsx
Description: Router wiring example for EasyStumpOut ReactSetv22026BSSC page set.
Version: v01
Date: 2026-04-14
============================================================================= */

import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";



import EasyStumpOut_HomePage_v01 from "./EasyStumpOut_HomePage_v01";

import EasyStumpOut_TermsOfService_ACTIVE from "./EasyStumpOut_TermsOfService_v01_active";
import EasyStumpOut_PrivacyPolicy_ACTIVE from "./EasyStumpOut_PrivacyPolicy_v01_active";
import EasyStumpOut_PaymentPage from "./EasyStumpOut_Payments_v01";


import {EASY_STUMP_OUT_LOCATION_DATA} from "../App_CONFIG_v01a";




const locationConfig = EASY_STUMP_OUT_LOCATION_DATA.cheyenne

export default function App_v01() {
  return (
    <BrowserRouter>
      <Routes>

        <Route path="/" element={<EasyStumpOut_HomePage_v01 locationConfig={locationConfig} />} />
        <Route path="/tos" element={<EasyStumpOut_TermsOfService_ACTIVE locationConfig={locationConfig}/>} />
        <Route path="/privacy" element={<EasyStumpOut_PrivacyPolicy_ACTIVE locationConfig={locationConfig}/>} />
        <Route path="/payments" element={<EasyStumpOut_PaymentPage locationConfig={locationConfig}/>} />

      </Routes>
    </BrowserRouter>
  );
}

/* =============================================================================
File: App_v01.tsx
Description: App/router example for EasyStumpOut using ReactSetv22026BSSC structure.
Version: v01
Date: 2026-04-14
============================================================================= */
